// LayoutWithSidebar.js
import React from "react";
import Sidebar from "../layouts/sidebar/Sidebar";
import Header from "../layouts/header/Header";

const LayoutWithSidebar = ({ children }) => {
  return (
    <div className="flex h-screen">
      {/* Sidebar */}
      <Sidebar />

      {/* Main Content */}
      <div className="flex-1 flex flex-col">
        {/* Header */}
        <Header />

        {/* Page Content */}
        <div className="p-4 bg-gray-100 flex-1 overflow-auto">{children}</div>
      </div>
    </div>
  );
};

export default LayoutWithSidebar;
